





import {Vue, Component} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class UserRoleMixin extends Vue {
    @Sync('auth/user') public user!: any;

    get userIsNull() {
        return nil(this.user);
    }

    get userIsCustomer() {
        return this.userIsNull || nil(this.user.roles) || this.user.roles.length === 0;
    }

    get userIsAdmin() {
        return !this.userIsCustomer && this.user.roles.indexOf('admin') > -1;
    }

    get userIsVendor() {
        return !this.userIsCustomer && this.user.roles.indexOf('vendor') > -1;
    }
}
